export enum AnnouncementType {
  Popup = 1,
}
